import React from 'react';

export default function CheckCircleIcon(props: React.SVGProps<SVGSVGElement>) {
    return (
        <svg width="30" height="30" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M0 8C0 3.58172 3.58172 0 8 0H40C44.4183 0 48 3.58172 48 8V40C48 44.4183 44.4183 48 40 48H8C3.58172 48 0 44.4183 0 40V8Z"
                fill="#059669"
            />
            <path
                d="M23.5001 14.9166C18.2101 14.9166 13.9167 19.21 13.9167 24.5C13.9167 29.79 18.2101 34.0833 23.5001 34.0833C28.7901 34.0833 33.0834 29.79 33.0834 24.5C33.0834 19.21 28.7901 14.9166 23.5001 14.9166ZM21.5834 29.2916L16.7917 24.5L18.143 23.1487L21.5834 26.5795L28.8572 19.3058L30.2084 20.6666L21.5834 29.2916Z"
                fill="white"
            />
        </svg>
    );
}
